/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface PostCharactersCharacterIdAssetsNames200Ok
 */
export interface PostCharactersCharacterIdAssetsNames200Ok {
    /**
     * item_id integer
     * @type {number}
     * @memberof PostCharactersCharacterIdAssetsNames200Ok
     */
    itemId: number;
    /**
     * name string
     * @type {string}
     * @memberof PostCharactersCharacterIdAssetsNames200Ok
     */
    name: string;
}

/**
 * Check if a given object implements the PostCharactersCharacterIdAssetsNames200Ok interface.
 */
export function instanceOfPostCharactersCharacterIdAssetsNames200Ok(value: object): value is PostCharactersCharacterIdAssetsNames200Ok {
    if (!('itemId' in value) || value['itemId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PostCharactersCharacterIdAssetsNames200OkFromJSON(json: any): PostCharactersCharacterIdAssetsNames200Ok {
    return PostCharactersCharacterIdAssetsNames200OkFromJSONTyped(json, false);
}

export function PostCharactersCharacterIdAssetsNames200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostCharactersCharacterIdAssetsNames200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'itemId': json['item_id'],
        'name': json['name'],
    };
}

export function PostCharactersCharacterIdAssetsNames200OkToJSON(json: any): PostCharactersCharacterIdAssetsNames200Ok {
    return PostCharactersCharacterIdAssetsNames200OkToJSONTyped(json, false);
}

export function PostCharactersCharacterIdAssetsNames200OkToJSONTyped(value?: PostCharactersCharacterIdAssetsNames200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'item_id': value['itemId'],
        'name': value['name'],
    };
}

